import type { ComponentType } from "react";
import { Grid, Paper } from "@mui/material";

import {
  RRD_LAYOUT_KEY,
  getRRDLayoutSpec,
} from "@/features/campaigns/direct-mail/rrd/utils/rrdLayoutHelper";
import BasicPostcard3CFixedLayout from "./BasicPostcard3CFixedLayout";
import BasicPostcard4CFixedLayout from "./BasicPostcard4CFixedLayout";
import BasicPostcard6CLayout from "./BasicPostcard6CLayout";
import DynamicPostcardLayout from "./DynamicPostcardLayout";
import MegaSheetLayout from "./MegaSheetLayout";
import ValueSheetInsertLayout from "./ValueSheetInsertLayout";
import type { RRDLayoutProps } from "./layoutTypes";

const LAYOUT_COMPONENTS: Record<string, ComponentType<RRDLayoutProps>> = {
  [RRD_LAYOUT_KEY.BASIC_POSTCARD_1H_6C]: BasicPostcard6CLayout,
  [RRD_LAYOUT_KEY.BASIC_POSTCARD_1H_4C_FIXED]: BasicPostcard4CFixedLayout,
  [RRD_LAYOUT_KEY.BASIC_POSTCARD_1H_3C_FIXED]: BasicPostcard3CFixedLayout,
  [RRD_LAYOUT_KEY.MEGA_SHEET_1L_1M_8C]: MegaSheetLayout,
  [RRD_LAYOUT_KEY.DYNAMIC_POSTCARD_1H_6C_FIXED]: DynamicPostcardLayout,
  [RRD_LAYOUT_KEY.VALUE_SHEET_INSERT_2H_12C]: ValueSheetInsertLayout,
};

type RRDLayoutRendererProps = Partial<RRDLayoutProps>;

function RRDLayoutRenderer({
  layoutSpec,
  layoutKey,
  ...props
}: RRDLayoutRendererProps) {
  const resolvedLayoutSpec =
    getRRDLayoutSpec(layoutKey) ||
    layoutSpec ||
    getRRDLayoutSpec(RRD_LAYOUT_KEY.BASIC_POSTCARD_1H_6C);
  const LayoutComponent =
    LAYOUT_COMPONENTS[resolvedLayoutSpec?.layoutKey] || BasicPostcard6CLayout;

  return (
    <Paper sx={{ p: 2 }} elevation={2}>
      <Grid container spacing={5} justifyContent="center">
        <LayoutComponent
          layoutSpec={resolvedLayoutSpec}
          {...(props as RRDLayoutProps)}
        />
      </Grid>
    </Paper>
  );
}

export default RRDLayoutRenderer;
